import { render, staticRenderFns } from "./FreeTextFieldsConfiguration.vue?vue&type=template&id=222d103d&scoped=true"
import script from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreeTextFieldsConfiguration.vue?vue&type=style&index=0&id=222d103d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d103d",
  null
  
)

export default component.exports